import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BotBlogrButton from "../../components/dashboard/BotBlogrButton";
import { H1Header } from "../../components";

const Help = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t("help-center", "Centre d'aide")} | BotBlogR</title>
        <meta name="description" content="Centre d'aide de la plateforme." />
      </Helmet>
      <div className="max-w-4xl mx-auto py-12 px-6">
        {/* Title */}
        <div className="flex items-center justify-center py-3">
          <H1Header title={"Centre d'aide"} />
        </div>

        <p className="text-gray-600 text-center mb-8">
          {t(
            "Retrouve ici toutes les informations pour t'aider à naviguer et contribuer à l'évolution du projet."
          )}
        </p>

        {/* Cards */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 mb-5 gap-6">
            {/* WhatsApp Community Card */}
            <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition cursor-pointer">
              <h2 className="text-xl font-semibold mb-2">
                {t("Join-whatsapp-community", "Rejoindre la communauté WhatsApp")}
              </h2>
              <p className="text-gray-600 mb-4">
                {t("Reçois les dernières updates, signale des bugs, fais des suggestions et échange avec d'autres utilisateurs.")}
              </p>
              <BotBlogrButton
              variant="violet"
                onClick={() =>
                  window.open(
                    "https://chat.whatsapp.com/K7WzNfCj0pMFzD4ASrp72u",
                    "_blank"
                  )
                }
              >
                {t("Join-community", "Rejoindre la communauté")}
              </BotBlogrButton>
            </div>

            {/* Feedback & Roadmap Card */}
            <div
              className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition cursor-pointer"
              onClick={() => navigate("/feedbacks")}
            >
              <h2 className="text-xl font-semibold mb-2">
                {t("Donner ton avis & suivre la roadmap")}
              </h2>
              <p className="text-gray-600 mb-4">
                {t("Nous nous basons sur les retours utilisateurs pour améliorer notre produit. Vote pour les idées qui comptent pour toi !")}
              </p>
              <BotBlogrButton variant="green" 

              >
  {t("Voir les feedbacks")}
</BotBlogrButton>
            </div>
          </div>

          {/* Contact by Email Card */}
          <div
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition cursor-pointer"
            onClick={() =>
              (window.location.href = "mailto:contact@botblogr.com")
            }
          >
            <h2 className="text-xl font-semibold mb-2">
              {t("Nous contacter directement par mail")}
            </h2>
            <p className="text-gray-600 mb-4">
              {t(
                "text-contact-us",
                "Si vous le souhaitez, vous pouvez aussi nous contacter directement par mail"
              )}
            </p>
            <BotBlogrButton
            variant="blue"
            >
              {t("Nous contacter par mail")}
            </BotBlogrButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default Help;
